import { render, staticRenderFns } from "./TaskName.vue?vue&type=template&id=0ec264de&scoped=true"
import script from "./TaskName.vue?vue&type=script&lang=js"
export * from "./TaskName.vue?vue&type=script&lang=js"
import style0 from "./TaskName.vue?vue&type=style&index=0&id=0ec264de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec264de",
  null
  
)

export default component.exports